export function groupRowsByRowspan(rows) {
  if (!Array.isArray(rows)) {
    return [];
  }

  const getCells = (row) => row?.relations?.TableCellsList || [];

  const colsCount = (cells) =>
    (cells || []).reduce(
      (sum, c) => sum + (Number(c?.fields?.colspan) || 1),
      0,
    );

  const computeMaxCols = (rowsList) =>
    rowsList.reduce((max, r) => Math.max(max, colsCount(getCells(r))), 0);

  const getRowMaxRowspan = (row) => {
    const rowspans = getCells(row)
      .map((c) => Number(c?.fields?.rowspan))
      .filter((n) => !Number.isNaN(n) && n > 0);
    return rowspans.length > 0 ? Math.max(...rowspans) : 1;
  };

  const ensureRelations = (r) => {
    if (!r.relations) {
      r.relations = {};
    }
  };

  const createPlaceholder = (rowId, colspan) => ({
    meta: {
      id: `placeholder-${rowId}-${colspan}`,
      key: `placeholder-${rowId}-${colspan}`,
      class: 'TableCell',
    },
    fields: {
      title: '',
      colspan,
      rowspan: 1,
    },
  });

  const adjustRowColspan = (r, faltan) => {
    const rCells = getCells(r);
    const last = rCells[rCells.length - 1];
    if (!last) {
      ensureRelations(r);
      r.relations.TableCellsList = [
        createPlaceholder(r?.meta?.id ?? 'r', faltan),
      ];
      return;
    }

    if (!last.fields) {
      last.fields = {};
    }

    let currentColspan = Number(last.fields.colspan);
    if (Number.isNaN(currentColspan) || currentColspan < 1) {
      currentColspan = 1;
    }

    last.fields.colspan = currentColspan + faltan;
  };

  const maxColsAcrossRows = computeMaxCols(rows);

  const groups = [];
  let i = 0;

  while (i < rows.length) {
    const row = rows[i];
    const maxRowspan = getRowMaxRowspan(row);

    const group = rows.slice(i, i + maxRowspan);

    for (const r of group) {
      const rCells = getCells(r);
      const currentCount = colsCount(rCells);

      if (currentCount === 0) {
        ensureRelations(r);
        r.relations.TableCellsList = [
          createPlaceholder(r?.meta?.id ?? `g${i}`, maxColsAcrossRows),
        ];
      } else if (currentCount < maxColsAcrossRows) {
        const faltan = maxColsAcrossRows - currentCount;
        adjustRowColspan(r, faltan);
      }
    }

    groups.push(group);
    i += maxRowspan;
  }

  return groups;
}
